import * as constants from './actions';

const initialState = {
    hiddenRepresentatives: [],
    isLocalRepPopupLoading: false,
    isRepDoubleCheckLoading: false,
    localRepData: {},
    localRepSetByUserInput: false,
    representativesVisibility: false,
    showDoubleCheckRepPopUp: false,
    showFindYouRepPopup: false,
    shouldPromptRepDoubleCheck: false
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.LOCAL_REP_SET_BY_USER_INPUT_ADDRESS:
            return {
                ...state,
                localRepSetByUserInput: true
            };
        case constants.ON_FIND_YOUR_REP_POPUP:
            return {
                ...state,
                showFindYouRepPopup: payload
            };
        case constants.ON_FIND_YOUR_REP_ERROR:
            return {
                ...state,
                isFindError: payload
            };
        case constants.SET_LOCAL_REPRESENTATIVE:
            return {
                ...state,
                localRepData: payload,
                hiddenRepresentatives: []
            };
        case constants.LOCAL_REP_GO_TO_FIND_SCREEN:
            return {
                ...state,
                nextActionIdentifier: payload
            };
        case constants.IS_LOCAL_REP_LOADING:
            return {
                ...state,
                isLocalRepLoading: payload
            };
        case constants.FIND_LOCAL_REP_POPUP_LOADING:
            return {
                ...state,
                isLocalRepPopupLoading: payload
            };
        case constants.ON_HIDE_REPRESENTATIVE:
            const hiddenRepresentatives = state.hiddenRepresentatives.concat(payload);
            return {
                ...state,
                hiddenRepresentatives: hiddenRepresentatives
            };
        case constants.ON_SHOW_REPRESENTATIVE:
            const visibleRepresentatives =
                state.hiddenRepresentatives.filter(e => e !== payload) || [];
            return {
                ...state,
                hiddenRepresentatives: visibleRepresentatives,
                representativesVisibility: false
            };
        case constants.ON_SHOW_LIST_WITH_REPS:
            return {
                ...state,
                representativesVisibility: !state.representativesVisibility
            };
        case constants.TOGGLE_DOUBLE_CHECK_REP_POPUP:
            return {
                ...state,
                showDoubleCheckRepPopUp: !state.showDoubleCheckRepPopUp
            };
        case constants.CLOSE_DOUBLE_CHECK_REP_POPUP:
            return {
                ...state,
                showDoubleCheckRepPopUp: false
            };
        case constants.SET_REP_DOUBLE_CHECK_LOADING:
            return {
                ...state,
                isRepDoubleCheckLoading: payload
            };
        case constants.SHOULD_PROMPT_REP_DOUBLE_CHECK:
            return {
                ...state,
                shouldPromptRepDoubleCheck: payload
            };
        default:
            return state;
    }
}
